export class ProjectModifiedOptions {
  selectedTemplate: PreviewApp.ProjectType | undefined;
  showNavPage?: boolean = false;
  appList: PreviewApp.UISaasValueType[] = [];
  saasUIData?: PreviewApp.UISaasValueType;
  withoutCot?: boolean = false;
}
